import classNames from 'classnames'

import { CurrencyCodeFlagIcon } from '@pages/IntroducingBroker/Dashboard/components/CurrencyCodeFlagIcon/CurrencyCodeFlagIcon'

import type { CurrencyType } from '@model/WalletDto'

import { Box } from '@shared/components/Box'
import { getFundingCurrencyIcon } from '@shared/components/Funding/FundingCurrencyIcons'

import styles from './WalletCurrencyIcon.module.scss'

type WalletCurrencyIconSize = 'badge' | 'group' | 'row'

interface WalletCurrencyIconProps {
  currencyCode: CurrencyType
  size?: WalletCurrencyIconSize
}

interface WalletCurrencyGroupIconProps {
  currencies: CurrencyType[]
}

const iconSizes: Record<WalletCurrencyIconSize, number> = {
  badge: 16,
  group: 18,
  row: 40,
}

export const WalletCurrencyIcon: React.FC<WalletCurrencyIconProps> = ({
  currencyCode,
  size = 'row',
}) => {
  const CryptoCurrencyIcon = getFundingCurrencyIcon(currencyCode)

  return (
    <Box className={styles.currencyIcon} radius='round' aria-hidden='true'>
      {CryptoCurrencyIcon ? (
        <CryptoCurrencyIcon size={iconSizes[size]} />
      ) : (
        <CurrencyCodeFlagIcon currencyType={currencyCode} size={iconSizes[size]} />
      )}
    </Box>
  )
}

export const WalletCurrencyGroupIcon: React.FC<WalletCurrencyGroupIconProps> = ({ currencies }) => {
  const visibleCurrencies = currencies.slice(0, 4)

  return (
    <Box
      className={classNames(styles.currencyGroup, {
        [styles.oneCurrency]: visibleCurrencies.length === 1,
        [styles.twoCurrencies]: visibleCurrencies.length === 2,
      })}
      aria-hidden='true'
    >
      {visibleCurrencies.map((currencyCode, index) => (
        <WalletCurrencyIcon
          key={`${currencyCode}-${index}`}
          currencyCode={currencyCode}
          size='group'
        />
      ))}
    </Box>
  )
}

export const WalletCryptoGroupIcon: React.FC = () => (
  <Box className={styles.currencyGroup} aria-hidden='true'>
    {['BTC', 'ETH', 'USDC', 'USDT'].map((currency) => {
      const Icon = getFundingCurrencyIcon(currency)

      return Icon ? (
        <Box key={currency} className={styles.currencyIcon}>
          <Icon size={16} />
        </Box>
      ) : null
    })}
  </Box>
)
